import { Element, Text } from "slate";

export function isEmptyValue(value: Element[]) {
  return (
    !value.length ||
    (value.length === 1 && value[0].type === "paragraph" && (value[0].children?.[0] as Text).text === "")
  );
}
